import axios from "axios";
import { getHeaders } from "../utility/getHeader";

const deleteRecord = async (tablename, colname, colval) => {
    try {
        console.log(`🗑️ Attempting to delete from ${tablename} where ${colname} = ${colval}`);
        
        // Log the headers to ensure auth is working
        const headers = getHeaders();
        console.log("🔑 Headers:", headers);
        
        // Log the full URL being called
        const url = `/deletebyid/${tablename}/${colname}/${colval}`;
        console.log("🌐 DELETE URL:", url);
        
        const res = await axios.delete(url, headers);
        
        console.log("✅ Delete response status:", res.status);
        console.log("✅ Delete response data:", res.data);
        
        return res.data;
    } catch (err) {
        console.error(`❌ Delete error for ${tablename}:`, err);
        
        // Log more detailed error information
        if (err.response) {
            console.error("❌ Response status:", err.response.status);
            console.error("❌ Response data:", err.response.data);
            console.error("❌ Response headers:", err.response.headers);
        } else if (err.request) {
            console.error("❌ Request error (no response):", err.request);
        } else {
            console.error("❌ Error message:", err.message);
        }
        
        throw err; // Re-throw the error so calling code can handle it
    }
};

// New bulk delete function
const deleteBulkRecords = async (tablename, colname, colvals) => {
    try {
        console.log(`🗑️ Attempting bulk delete from ${tablename} where ${colname} in [${colvals.join(', ')}]`);
        
        // Log the headers to ensure auth is working
        const headers = getHeaders();
        console.log("🔑 Headers:", headers);
        
        // Convert array of values to comma-separated string
        const valsString = colvals.join(',');
        
        // Log the full URL being called
        const url = `/deletbulkdatabyid/${tablename}/${colname}/${valsString}`;
        console.log("🌐 BULK DELETE URL:", url);
        
        const res = await axios.delete(url, headers);
        
        console.log("✅ Bulk delete response status:", res.status);
        console.log("✅ Bulk delete response data:", res.data);
        
        return res.data;
    } catch (err) {
        console.error(`❌ Bulk delete error for ${tablename}:`, err);
        
        // Log more detailed error information
        if (err.response) {
            console.error("❌ Response status:", err.response.status);
            console.error("❌ Response data:", err.response.data);
            console.error("❌ Response headers:", err.response.headers);
        } else if (err.request) {
            console.error("❌ Request error (no response):", err.request);
        } else {
            console.error("❌ Error message:", err.message);
        }
        
        throw err; // Re-throw the error so calling code can handle it
    }
};

export default deleteRecord;
export { deleteBulkRecords };